import { Button, Modal, Form as BForm } from '@themesberg/react-bootstrap'
import React from 'react'
import CountryTable from '../../../../components/CountryTable'
import { checkIsTenant } from '../../../../utils/constants'
import { getItem } from '../../../../utils/storageUtils'

const CountryModal = ({
  show,
  code,
  search,
  setShow,
  loading,
  setSearch,
  myCountries,
  editCurrency,
  tenantDetails,
  selectedPortal,
  selectedCountries,
  handleCountrySelect,
  setSelectedCountries,
  enableEdit
}) => {
  return (
    <Modal show={show} onHide={() => setShow(false)} size='lg'>
      <Modal.Header className='justify-content-center'>
        <h5>{enableEdit ? 'Update' : ''} Country Data for {code}</h5>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex justify-content-end align-items-center mb-3 mx-2'>
          <BForm.Control
            type='text'
            placeholder='Search Country Name'
            size='sm'
            style={{ maxWidth: '230px' }}
            value={search}
            onChange={(event) => {
              setSearch(event.target.value.replace(/[^\w\s\n]/gi, ''))
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') e.preventDefault()
            }}
          />
        </div>
        <CountryTable
          loading={loading}
          myCountries={myCountries}
          selectedCountries={selectedCountries}
          enableEdit={enableEdit}
          handleCountrySelect={handleCountrySelect}
          setSelectedCountries={setSelectedCountries}
        />
      </Modal.Body>

      <Modal.Footer className='justify-content-between'>
        <Button variant='outline-warning' onClick={() => { setShow(false) }}>
          Cancel
        </Button>

        {enableEdit &&
          <Button
            variant='outline-success'
            onClick={() => {
              const data = tenantDetails?.tenantConfig?.currencyCountry
              editCurrency({
                currencyCountry: data && Object.keys(data)?.length
                  ? { ...data, [code]: selectedCountries }
                  : { [code]: selectedCountries },
                tenantId: checkIsTenant() ? getItem('tenant-id') : selectedPortal || '',
                code
              })
              setShow(false)
            }}
          >
            Confirm
          </Button>}
      </Modal.Footer>
    </Modal>
  )
}

export default CountryModal
